<template>
  <page-outline :title="$t('administration.profile_edit')">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutters">
        <back-button></back-button>
      </b-row>
      <spinner v-if="activateSpinner"></spinner>
      <form-accordion v-if="!activateSpinner" :title="$t('administration.profile_info')"  :isTitleUpperCase="false">
        <b-row>
          <b-col sm="12" class="form-group">
            <form-write-group-label-input v-model="libelle" isMandatory
              :inputLabel="$t('administration.label')" :placeholderValue="$t('administration.label')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12"><label>{{ $t('administration.right') }}</label></b-col>
          <b-col sm="4" class="form-group" v-for="(right, index) in rightList" :key="index">
            <b-form-checkbox v-model="rightList[index].state"
              :value="1"
              :unchecked-value="0">
              <span>{{ $t('rights.db_rights.' + right.name) === ('rights.db_rights.' + right.name) ? right.name : $t('rights.db_rights.' + right.name) }}</span>
            </b-form-checkbox>
          </b-col>
        </b-row>
      </form-accordion>
      <b-row v-if="!activateSpinner" class="accordionForm mt-3 justify-content-end form-group p-0 pr-2 no-gutters">
        <b-button variant="primary"
          @click="changeProfil()">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'

import {loadPage} from '@/helpers/routing'
// import {validateAccountFormat, validateEmail, validateSIREN, validatePhoneNumber} from '@/helpers/validator'

export default {
  name: 'EditProfilCompany',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner
  },
  props: ['id_rights_profile', 'idCompany'],
  computed: {
    realStatusList () {
      let that = this
      const list = []
      for (const property in that.statusList) {
        const status = that.statusList[property]
        list.push({
          name: status.name,
          state: status.state
        })
      }
      return list
    },
    statusDisplay () {
      let allStatus = Object.keys(this.$engine.rights.getAll())
      let realStatusList = Object.keys(allStatus).filter(elem => allStatus[elem])
      this.rights = allStatus
    },
  },
  data () {
    return {
      activateSpinner: false,
      libelle: '',
      redirection: this.$engine.company.redirection,
      rights: [],
      select_rights: [],
      rightList: [],
      Profil: []
    }
  },
  created () {
    this.activateSpinner = true
    this.testList = [{
      name: 'droit 1',
      state: '1'
    },{
      name: 'droit 2',
      state: '0'
    },{
      name: 'droit 3',
      state: '0'
    },{
      name: 'droit 4',
      state: '1'
    },{
      name: 'droit 5',
      state: '0'
    },]
    this.rights = this.$engine.company.rightsL
    if (this.id_rights_profile !== '') {
      this.getProfile(this.id_rights_profile)
    }
  },
  mounted () {
  },
  methods: {
    getProfile (idProfile) {
      let that = this
      that.Profil = []
      that.$engine.profilcompany.getProfil(
        idProfile
      ).then(resp => {
        let requests = {}
        requests = resp.data.profil
        that.Profil = requests
        this.loadProfileRights()
      }).catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    loadProfileRights () {
      this.libelle = this.Profil.libelle
      this.idRight = this.Profil.rights
      for (let right of Object.values(this.rights)) {
        if (this.Profil.rights.map(elem => elem.Libelle).indexOf(right) !== -1) {
          this.rightList.push({name: right, state: 1})
        } else {
          this.rightList.push({name: right, state: 0})
        }
      }
      this.activateSpinner = false
    },
    changeProfil () {
      let that = this
      for (let el of this.rightList) {
        if (el.state === 1/* && this.Profil.rights.map(elem => elem.name).indexOf(el.name) !== -1*/) {
          this.select_rights.push(el.name)
        }
      }
      this.$engine.profilcompany.editProfil(
        this.idCompany,
        this.id_rights_profile,
        this.libelle,
        this.select_rights
      ).then(resp => {
        that.$f7.modal({
          title: that.$i18n.t('administration.edit_profile'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/company/' + that.redirection})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.$f7.modal({
          title: that.$i18n.t('administration.edit_error'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      })
    }
  }
}
</script>
